import { useState } from 'react';
import { cardItems } from '@/mocks/home';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            热播剧集
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            本周热度和口碑双丰收的精选剧集，每一部都值得熬夜追完
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 md:gap-6">
          {cardItems.map((item) => (
            <CardItem key={item.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}

function CardItem({ item }: { item: typeof cardItems[0] }) {
  const [imgError, setImgError] = useState(false);

  return (
    <div className="group rounded-xl overflow-hidden bg-background-100 border border-background-200/70 transition-all duration-300 hover:scale-[1.02] cursor-pointer flex flex-col">
      {!imgError && (
        <div className="relative aspect-[3/4] overflow-hidden">
          <img
            src={item.image}
            alt={item.title}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            onError={() => setImgError(true)}
          />
          <div className="absolute top-3 left-3 flex gap-2">
            <span className="px-2.5 py-1 text-xs font-medium rounded-full bg-primary-500 text-background-50 whitespace-nowrap">
              {item.tag}
            </span>
            <span className="px-2.5 py-1 text-xs font-medium rounded-full bg-accent-500/90 text-background-50 whitespace-nowrap">
              {item.rating}
            </span>
          </div>
        </div>
      )}

      <div className="p-4 flex flex-col flex-1">
        <h3 className="text-base font-heading font-bold text-foreground-900 group-hover:text-primary-500 transition-colors">
          {item.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500">{item.subtitle}</p>
        <p className="mt-3 text-xs text-foreground-600 leading-relaxed line-clamp-3">
          {item.desc}
        </p>
      </div>
    </div>
  );
}